import './Skeleton.scss';

/**
 * One placeholder bar, for a section whose request is still in flight.
 *
 * A skeleton is built by dropping these into the page's *own* layout classes
 * rather than approximating them, so every box is already the size it will be
 * and only the contents are stand-ins — see `DashboardSkeleton` for the shape
 * that takes. Nothing here sizes itself: `w` and `h` are the caller's, because
 * the widths are what make a skeleton read as the layout it is replacing.
 *
 *   light   the tone that reads on a blue/gradient fill, where 6% white is invisible
 *   pill    fully round, for avatars and chips
 *   radius  overrides the 6px default (the checkout tiles draw 4)
 */
export default function Skeleton({ w, h = 12, radius, light, pill, className = '' }) {
  return (
    <span
      className={[
        'skel',
        light && 'skel--light',
        pill && 'skel--pill',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      style={{ width: w, height: h, ...(radius != null && { borderRadius: radius }) }}
    />
  );
}
